import { useEffect } from 'react'
import ModalCustom from '../../../modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import { updateGroupsAPI, deleteGroupsAPI } from '../../../../services/division'
import LabelCustom from '../../../label-custom'
import Error_false from '../../../error/error-false'
import Swal from 'sweetalert2'
import { useSelector } from 'react-redux'
import SwalCustom from '../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../Constants'
const schema = yup
  .object({
    division: yup.string().required('Please, Input character of Group'),
    divisionEn: yup.string().required('Please, Input Group for English'),
    divisionTh: yup.string().required('Please, Input Group for Thai')
  })
  .required()
export default function EditGroup({
  setIsSave,
  showCreate,
  isSave,
  setShowCreate,
  detail,
  setIsRefresh,
  fnGetData,
  handleKeyDownTH,
  handleKeyDownEN,
  handleKeyDownNum
}) {
  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const orgId = useSelector((state) => state.roleReducer.role)

  useEffect(() => {
    setValue('division', detail.division ?? '')
    setError('division', false)

    setValue('divisionEn', detail.division_en ?? '')
    setError('divisionEn', false)

    setValue('divisionTh', detail.division_th ?? '')
    setError('divisionTh', false)

    setValue('larkEnable', detail?.lark_enable ?? false)
  }, [
    detail.division,
    detail.division_en,
    detail.division_th,
    detail?.lark_enable,
    setError,
    setValue
  ])

  const onSubmit = (d) => {
    // event.preventDefault()

    // const onSubmit = (d) => {
    const param = { divisionId: detail.id, orgId }
    const body = {
      division: d.division,
      divisionEn: d.divisionEn,
      divisionTh: d.divisionTh,
      larkEnable: d.larkEnable??false
    }


    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to save the changes?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        updateGroup(param, body)
      }
    })
  }

  const updateGroup = async (param, body) => {
    const results = await updateGroupsAPI(param, body)
    setIsSave(false)
    if (!results) return
    if (results.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        setIsRefresh(true)
        setShowCreate(false)
        fnGetData()
        fnReset()
      })
    } else {
      Error_false(results)
    }
  }

  const fnReset = () => {
    setError('division', false)
    setError('division_en', false)
    setError('division_th', false)
  }

  const handleClose = () => {
    setShowCreate(false)
    fnReset()
  }

  const handleOnDelete = (result) => {
    const param = { divisionId: detail.id, orgId: orgId }

    SwalCustom({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          const results = await deleteGroupsAPI(param)
          if (!results) return
          if (results.status) {
            setShowCreate(false)
            fnGetData()
            Swal.fire('Deleted!', 'Your file has been deleted.', 'success')
          } else {
            Error_false(results)
          }
        }
      })
      .then(() => {
        setIsRefresh(true)
      })
  }

  return (
    <ModalCustom width={500} open={showCreate} onCancel={handleClose}>
      <Form
        className="mt-3 row"
        style={{ rowGap: '13px' }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <label className="text-primary">Update Group</label>
        <Col md={12}>
          <LabelCustom text={'Group'} />
          <Controller
            name={'division'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={2}
                // value={division}
                value={value}
                onChange={onChange}
                // onChange={onHandleGroupChange}
                onKeyDown={handleKeyDownEN}
              />
            )}
          />
          {errors.division?.message && (
            <label className="small text-danger">
              {errors.division.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Group EN'} />
          <Controller
            name={'divisionEn'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={100}
                value={value}
                onChange={onChange}
                // value={divisionEN}
                // onChange={onHandleGroupENChange}
                // onKeyDown={handleKeyDownEN}
              />
            )}
          />

          {errors.divisionEn?.message && (
            <label className="small text-danger">
              {errors.divisionEn.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Group TH'} />
          <Controller
            name={'divisionTh'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={100}
                value={value}
                onChange={onChange}
                // value={divisionTH}
                // onChange={onHandleGroupTHChange}
                // onKeyDown={handleKeyDownTH}
              />
            )}
          />

          {errors.divisionTh?.message && (
            <label className="small text-danger">
              {errors.divisionTh.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <Controller
            name={'larkEnable'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Group
                className="mb-3"
                controlId="formBasicCheckbox"
                value={value}
                onChange={onChange}
              >
                <Form.Check
                  checked={value}
                  type="checkbox"
                  label="Lark Enable"
                />
              </Form.Group>
            )}
          />
        </Col>

        <Col xl={12} className="text-center ">
          {detail.count_emp === 0 && (
            <Button
              className="px-4 me-2 bg-danger text-white"
              variant="light"
              type="button"
              disabled={isSave}
              onClick={handleOnDelete}
            >
              Delete
            </Button>
          )}
          <Button
            className="px-4 "
            disabled={isSave}
            type="submit"
            // onClick={onSubmit}
          >
            {isSave ? 'Saving...' : 'Save'}
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
